import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Pipe({ name: 'certificationExpirationIcon' })
export class CertificateExpirationIconPipe implements PipeTransform {
    transform(expirationDate: Moment): string {
        const today = moment().startOf('day');

        const duration = moment.duration(today.diff(expirationDate));
        const durationInMonths = duration.asMonths();

        if (durationInMonths < 3 && durationInMonths > 0) {
            return 'error';
        } else if (durationInMonths <= 0 && durationInMonths >= -3) {
            return 'exclamation';
        }
    }
}
